import { Box, CircularProgress, Typography } from "@mui/material";
import CollapsibleTableWithPagination from "../../components/CollapsibleTableWithPagination";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from "../../components/ScrollIndicatorsComp/ScrollIndicatorsComp";
import { LoadedPagesData } from "./PayrollHistoryResultsData";
import { ProgressStyle, noWrapTextStyle } from "./styled";

export interface PayrollHistoryResultsProps {
  data: LoadedPagesData,
  onLoadNextPage: (page: number) => void,
  loading: boolean,
  currentPage: number,
  startDate: string,
  endDate: string,
  noData: boolean
}

export const PayrollHistoryResults: React.FC<PayrollHistoryResultsProps> = ({
  data,
  onLoadNextPage,
  loading,
  currentPage,
  startDate,
  endDate,
  noData
}) => {
  const headerCells = [
    <Typography>Date</Typography>, 
    <Typography>Shift</Typography>, 
    <Typography>Site</Typography>, 
    <Typography>Vessel</Typography>, 
    <Typography>Occupation</Typography>, 
    <Typography>Hrs.</Typography>
  ];

  if (loading) {
    return (
      <Box sx={ProgressStyle} data-automation="loading">
        <CircularProgress />
      </Box>
    )
  }
  return (
    <MainContainer>
      <Typography className="sub-title" data-automation="date-range-label">Start Date: {startDate} - End Date: {endDate}</Typography>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <CollapsibleTableWithPagination
            data={data.loadedRecords.map(r => !r ? r : ({
              date: <Typography sx={noWrapTextStyle}>{r.date}</Typography>,
              shift: <Typography sx={{ textAlign: 'center', fontSize: 'inherit' }}>{r.shift}</Typography>,
              sit: r.site,
              vessel: r.vessel,
              occupation: <Typography sx={{ overflowWrap: 'break-word', fontSize: 'inherit' }}>{r.occupation}</Typography>,
              hours: r.hours,
              details: r.details.map((d, key) => ({
                site: r.site,
                vessel: r.vessel,
                occupation: r.occupation,
                shift: d.shift,
                ot: d.ot,
                tt: d.tt,
                key
              }))
            }))}
            pageSize={data.pageSize}
            onLoadNextPage={onLoadNextPage}
            headerCells={headerCells}
            expandedRowProp='details'
            collapsibleHeaderCells={['Site', 'Vessel', 'Occupation', 'Shift', 'O.T.', 'T.T.']}
            collapsibleColumnWidths={['24%', '24%', '24%', '9.33%', '9.33%', '9.33%']}
            currentPage={currentPage}
            noData={noData}
          />
        </ScrollIndicatorsComp>
      </Typography>
    </MainContainer>
  )
}